import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { HeaderComponent } from "../header/header.component";
import { OurClienteleComponent } from "../our-clientele/our-clientele.component";
import { ClientsReviewComponent } from "../clients-review/clients-review.component";
import { GetStartedTodayComponent } from "../get-started-today/get-started-today.component";
import { FooterComponent } from "../footer/footer.component";
import { RouterModule } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { JsonLdService } from '../services/json-ld.service';

@Component({
  selector: 'app-integration',
  templateUrl: './integration.component.html',
  styleUrls: ['./integration.component.css'],
  standalone: true,
  imports: [
    HeaderComponent,
    RouterModule,
    OurClienteleComponent,
    ClientsReviewComponent,
    GetStartedTodayComponent,
    FooterComponent
  ],
})
export class IntegrationComponent implements OnInit {
  userDetail: any;
  isBrowser: boolean;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private jsonLdService: JsonLdService
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }
  ngOnInit() {
    const integrationsJsonLd = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          "@id": "https://kudoshub.com/#organization",
          "name": "KudosHub",
          "url": "https://kudoshub.com",
          "logo": {
            "@type": "ImageObject",
            "url": "https://kudoshub.com/theme/images/og-images/logo.webp",
            "thumbnailUrl": "https://kudoshub.com/theme/images/og-images/logo.webp",
            "width": 160,
            "height": 160
          },
          "sameAs": [
            "https://www.facebook.com/KudosHub/",
            "https://www.linkedin.com/company/kudoshub/",
            "https://www.youtube.com/channel/UCN_L5eAxhiRYcjMd60y4gwg",
            "https://x.com/KudosHub"
          ],
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Kalidas Road",
            "addressLocality": "Inder Vihar",
            "addressRegion": "Dehradun",
            "postalCode": "248001",
            "addressCountry": "IN"
          },
          "contactPoint": [
            {
              "@type": "ContactPoint",
              "telephone": "+91-9997100097",
              "contactType": "customer support",
              "availableLanguage": "en"
            }
          ]
        },
        {
          "@type": "WebSite",
          "@id": "https://kudoshub.com/#website",
          "url": "https://kudoshub.com",
          "name": "KudosHub",
          "description": "KudosHub is an AI-powered email intelligence platform that helps businesses improve deliverability, reduce bounce rates, and maintain clean data with unmatched accuracy. It offers real-time Email Validation, AI Email Scoring, and advanced APIs that detect invalid, disposable, catch-all, and risky addresses. With 99% verified accuracy, pay-as-you-go pricing, and the industry’s lowest cost per validation, KudosHub empowers marketers, SaaS platforms, and B2B data providers to protect sender reputation and optimize campaign performance worldwide.",
          "publisher": {
            "@id": "https://kudoshub.com/#organization"
          }
        },
        {
          "@type": "WebPage",
          "@id": "https://kudoshub.com/integrations/#webpage",
          "url": "https://kudoshub.com/integrations",
          "name": "Connect KudosHub with Clay, Apollo, HubSpot, Zapier & More",
          "description": "Explore KudosHub integrations for CRMs, ESPs, and APIs. Connect, sync, and validate emails with 99% accuracy while automating workflows in minutes.",
          "inLanguage": "en",
          "isPartOf": {
            "@id": "https://kudoshub.com/#website"
          },
          "mainEntity": {
            "@id": "https://kudoshub.com/integrations/#service"
          },
          "datePublished": "2025-11-07T11:30:00+05:30",
          "dateModified": "2025-11-07T11:30:00+05:30"
        },
        {
          "@type": "Service",
          "@id": "https://kudoshub.com/integrations/#service",
          "name": "KudosHub Email Validation and Integration",
          "serviceType": "Email Validation and Integration",
          "description": "KudosHub Integrations allow businesses to connect email validation with CRMs, ESPs, and marketing tools effortlessly. Automate email verification, sync clean data in real time, and maintain 99% accuracy across platforms like Clay, Apollo, HubSpot, Zapier, and Mailchimp.",
          "offers": {
            "@type": "AggregateOffer",
            "url": "https://kudoshub.com/integrations/#pricing",
            "priceCurrency": "USD",
            "lowPrice": "0",
            "highPrice": "0.0034",
            "offerCount": 2,
            "offers": [
              {
                "@type": "Offer",
                "name": "30-Day Free Trial (100 daily credits)",
                "description": "3,000 complimentary email validations (100 per day) for new users.",
                "price": "0",
                "priceCurrency": "USD",
                "url": "https://kudoshub.com/signup",
                "availability": "https://schema.org/InStock",
                "priceSpecification": {
                  "@type": "UnitPriceSpecification",
                  "unitText": "email validations",
                  "price": "0",
                  "unitCode": "C62"
                }
              },
              {
                "@type": "Offer",
                "name": "Commercial Volume Pricing",
                "description": "Per-validation cost drops from $0.0034 (low volume) down to $0.00055 (high volume). Enterprise quotes available.",
                "url": "https://kudoshub.com/#pricing",
                "availability": "https://schema.org/InStock",
                "priceSpecification": {
                  "@type": "UnitPriceSpecification",
                  "unitText": "email validations",
                  "priceCurrency": "USD",
                  "minPrice": "0.00055",
                  "maxPrice": "0.0034"
                }
              }
            ]
          },
          "provider": {
            "@id": "https://kudoshub.com/#organization"
          },
          "url": "https://kudoshub.com/integrations",
          "areaServed": {
            "@type": "AdministrativeArea",
            "name": "Worldwide"
          }
        }
      ]
    };
    const integrationsBreadcrumb = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "@id": "https://kudoshub.com/integrations/#breadcrumb",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://kudoshub.com/"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Integrations",
          "item": "https://kudoshub.com/integrations/"
        }
      ]
    };
    const integrationFAQ = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "@id": "https://kudoshub.com/integrations#faq",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What are KudosHub integrations and how to connect with other tools?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "KudosHub integrations let you connect your email validation engine with CRMs, ESPs, and automation tools. You can integrate using APIs, Zapier, or native connections. Once linked, your email lists are validated automatically, keeping your data accurate and your campaigns performing with 99% accuracy."
          }
        },
        {
          "@type": "Question",
          "name": "Which platforms can I connect with KudosHub?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "KudosHub integrates with popular CRMs, ESPs, and automation tools, including HubSpot, Clay, Apollo, Mailchimp, and Zapier. You can also connect with custom platforms through our REST API or webhook integrations to automate validation directly inside your existing workflow."
          }
        },
        {
          "@type": "Question",
          "name": "How do I integrate KudosHub with my CRM or ESP?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "You can integrate KudosHub with your CRM or ESP using built-in connectors, Zapier, or custom API calls. Once connected, KudosHub automatically validates new and existing contacts, ensuring only verified and deliverable email addresses enter your system."
          }
        },
        {
          "@type": "Question",
          "name": "Can KudosHub integrate with no-code tools like Zapier for automation?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes. KudosHub integrates seamlessly with Zapier, allowing you to automate email validation and scoring across more than 2,000 apps. No coding is required. Simply create a Zap, connect your accounts, and start syncing clean, validated data in real time."
          }
        },
        {
          "@type": "Question",
          "name": "How long does it take to set up a KudosHub integration?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Most KudosHub integrations can be set up in just a few minutes. With ready-to-use connectors, Zapier templates, and a simple API structure, you can start validating emails, syncing contacts, and automating workflows almost instantly without technical expertise."
          }
        },
        {
          "@type": "Question",
          "name": "What types of integrations does KudosHub support (e.g., real-time vs. bulk)?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "KudosHub supports both real-time and bulk integrations. Real-time validation checks email addresses instantly during signups or form submissions, while bulk integrations let you upload large lists for batch processing. Both methods ensure high accuracy and prevent invalid data from entering your system."
          }
        },
        {
          "@type": "Question",
          "name": "How does KudosHub’s API ensure real-time email verification during form submissions?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "KudosHub’s API uses advanced syntax, domain, and mailbox-level checks to verify email addresses instantly during form submissions. It flags invalid, disposable, or risky emails in real time, ensuring only verified contacts are stored and maintaining high deliverability rates."
          }
        },
        {
          "@type": "Question",
          "name": "How do I handle errors and troubleshooting in KudosHub API calls?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "KudosHub provides detailed API responses and status codes to help identify issues quickly. You can monitor request logs, use sandbox mode for testing, and access developer documentation for troubleshooting guides and sample code. Our support team is also available for live technical assistance."
          }
        },
        {
          "@type": "Question",
          "name": "Is there a limit to how many tools I can integrate with KudosHub?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "No, there is no limit. You can integrate KudosHub with as many tools, CRMs, or platforms as your workflow requires. Our API and Zapier connections are designed to scale, making it easy to manage multiple integrations without affecting performance or accuracy."
          }
        },
        {
          "@type": "Question",
          "name": "How can API integration help reduce email bounce rates and improve deliverability?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "By validating every address through the KudosHub API before sending, you eliminate invalid or temporary emails that cause bounces. This maintains sender reputation, improves inbox placement, and ensures your campaigns reach real, active recipients to increase overall deliverability and engagement."
          }
        },
        {
          "@type": "Question",
          "name": "How secure are KudosHub integrations when handling user data?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "KudosHub protects all integrations with enterprise-grade encryption, GDPR compliance, and secure data transfer protocols. API requests use HTTPS and token-based authentication to ensure that your data remains private, protected, and accessible only to authorized systems or users."
          }
        },
        {
          "@type": "Question",
          "name": "Can KudosHub build custom integrations for my specific platform?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes. Our development team can help you build or adapt custom integrations tailored to your platform. Whether it is a private CRM, ESP, or proprietary system, KudosHub’s API and webhook framework make it easy to create secure, scalable, and automated validation workflows."
          }
        },
        {
          "@type": "Question",
          "name": "Is there a free tier or trial for testing KudosHub API integrations?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes. KudosHub offers 3,000 free credits to test API integrations and evaluate performance. You can start validating emails, checking real-time responses, and automating workflows without any setup costs or long-term commitments."
          }
        },
        {
          "@type": "Question",
          "name": "How can I integrate KudosHub’s AI Email Scoring into my existing tools or workflows?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "You can integrate KudosHub’s AI Email Scoring through our API or Zapier to analyze engagement likelihood, quality, and risk levels. The scoring system works alongside validation, providing actionable insights that help you prioritize high-value leads and improve campaign ROI automatically."
          }
        }
      ]
    };
    this.jsonLdService.addJsonLd(integrationsJsonLd, integrationsBreadcrumb, integrationFAQ);
  }




  setUserDetails(data) {
    this.userDetail = data.userDetail;
  }
}
